export const items = [
  [
    {
      name: 'Incident Response',
      icon: '/technology-ico4.svg',
      link: '/services/incident-response'
    },
    {
      name: 'MDR',
      icon: '/ManagedXDR.svg',
      link: '/services/mdr'
    },
  ]
];

export const label = 'Services';
